import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const ContactdetailsPanel = () => {
  const [ContactDetail, setContactDetail] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/contact_info_list"
      );
      setContactDetail([response.data.data]);
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Contact Details</h2>

      {ContactDetail.map((Data, index) => (
        <div key={index} className="border rounded p-4 mb-4 shadow-sm bg-light">
          <div className="d-flex justify-content-end">
            <Link to={`/Contact-Detail-edit/${Data.contact_id}`}>
              <button className="btn btn-primary btn-sm me-2">
                <i className="fa-regular fa-pen-to-square text-white"></i> Edit
              </button>
            </Link>
          </div>
          <p><strong>Address:</strong> {Data.cont_address}</p>
          <p><strong>Email:</strong> {Data.cont_email}</p>
          <p><strong>Landline Number:</strong> {Data.cont_landline}</p>
          <p><strong>Phone Number:</strong> {Data.cont_phone}</p>
          <p><strong>WhatsApp Number:</strong> {Data.cont_whatsapp}</p>
        </div>
      ))}
    </div>
  );
};

export const EditContactDetails = () => {
  const [ContactDetailsUser, setContactDetailsUser] = useState({
    cont_address: "",
    cont_email: "",
    cont_landline: "",
    cont_phone: "",
    cont_whatsapp: ""
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setContactDetailsUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const ContactDetailData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_contact_info_by_id`,
          {
            contact_id: id,
          }
        );
        setContactDetailsUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    ContactDetailData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("contact_id", id);
    formData.append("cont_address", ContactDetailsUser.cont_address);
    formData.append("cont_email", ContactDetailsUser.cont_email);    
    formData.append("cont_landline", ContactDetailsUser.cont_landline);
    formData.append("cont_phone", ContactDetailsUser.cont_phone);
    formData.append("cont_whatsapp", ContactDetailsUser.cont_whatsapp);

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_contact_info`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.success(response.data.message || "Data updated successfully");
        navigate("/Contact-Detail");
      } else {
        toast.error(response.data.message || "Failed to update Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };


  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Contact Details</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea
                  rows={3}
                  type="text"
                  value={ContactDetailsUser.cont_address}
                  onChange={changeHandler}
                  className="form-control"
                  name="cont_address"
                  id='cont_address'
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="text"
                  value={ContactDetailsUser.cont_email}
                  onChange={changeHandler}
                  className="form-control"
                  name="cont_email"
                  id='cont_email'
                />
              </div>

              <div className="mb-3">
                <label className="form-label">LandLine Number</label>
                <input
                  type="text"
                  value={ContactDetailsUser.cont_landline}
                  onChange={changeHandler}
                  className="form-control"
                  name="cont_landline"
                  id='cont_landline'
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input
                  type="text"
                  value={ContactDetailsUser.cont_phone}
                  onChange={changeHandler}
                  className="form-control"
                  name="cont_phone"
                  id='cont_phone'
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Whatsapp Number</label>
                <input
                  type="text"
                  value={ContactDetailsUser.cont_whatsapp}
                  onChange={changeHandler}
                  className="form-control"
                  id='cont_whatsapp'
                  name="cont_whatsapp"
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Contact-Detail">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
